import template from './index.pug'

export default Vue.extend({
  name: 'accessibility-statement-page',
  template: template(),
  created() {
    window.scrollTo(0, 0)
  }
})